'use client';
import Image from 'next/image';
import { useState } from 'react';

const PLACEHOLDER = '/achievements/_placeholder.png';

interface Props {
  iconFile: string;
  alt: string;
  /** Fixed render size in px. Ignored when `fill` is set. Default 96. */
  size?: number;
  /** Fill the (relative, sized) parent instead of using a fixed px size. */
  fill?: boolean;
  className?: string;
  /** Fires when the image has finished loading (or the placeholder fallback did). */
  onLoad?: () => void;
}

// Source art is 1024×1024 — next/image down-scales it to the rendered size
// (with a 2× retina srcset) instead of shipping the full-res PNG.
export function AchievementIcon({ iconFile, alt, size = 96, fill, className, onLoad }: Props) {
  // Derive src synchronously from the prop so the icon updates in place when
  // iconFile changes (no remount/reload flash). Fallback is tracked per-file.
  const [erroredFile, setErroredFile] = useState<string | null>(null);
  const src = erroredFile === iconFile ? PLACEHOLDER : `/achievements/${iconFile}`;
  const onError = () => setErroredFile(iconFile);

  if (fill) {
    return (
      <Image src={src} fill sizes="60vw" quality={90} alt={alt} className={className} onError={onError} onLoad={onLoad} />
    );
  }
  return (
    <Image
      src={src}
      width={size}
      height={size}
      sizes={`${size}px`}
      quality={90}
      alt={alt}
      className={className}
      onError={onError}
      onLoad={onLoad}
    />
  );
}
